<template>
  <v-container class="py-8" style="max-width: 480px;">
    <v-sheet outlined rounded="lg" class="pa-6 text-center">
      <template v-if="!token">
        <v-icon size="48" color="#EC2E2E" class="mb-3">mdi-alert-circle-outline</v-icon>
        <div class="text-h6 font-weight-bold mb-2">Ссылка неверна</div>
        <div class="text-body-2 grey--text text--darken-1">
          В ссылке нет токена отмены. Проверьте, что вы перешли по полной ссылке из письма.
        </div>
      </template>

      <template v-else-if="cancellation.done">
        <v-icon size="48" color="#009E60" class="mb-3">mdi-check-circle-outline</v-icon>
        <div class="text-h6 font-weight-bold mb-2">Запись отменена</div>
        <div class="text-body-2 grey--text text--darken-1">
          Время освобождено для других записей.
        </div>
      </template>

      <template v-else-if="cancellation.conflict">
        <v-icon size="48" color="#8a8f9c" class="mb-3">mdi-information-outline</v-icon>
        <div class="text-h6 font-weight-bold mb-2">Запись уже неактуальна</div>
        <div class="text-body-2 grey--text text--darken-1">
          Эту запись уже отменили или она была обработана ранее.
        </div>
      </template>

      <template v-else>
        <v-icon size="48" color="#483CB9" class="mb-3">mdi-calendar-remove-outline</v-icon>
        <div class="text-h6 font-weight-bold mb-2">Отменить запись?</div>
        <div class="text-body-2 grey--text text--darken-1 mb-4">
          Мы уведомим эксперта, а время станет доступно для других записей.
        </div>

        <v-alert v-if="cancellation.error.length" type="error" dense text class="mb-4">
          Не удалось отменить запись. Попробуйте ещё раз позже.
        </v-alert>

        <v-btn color="#EC2E2E" dark :loading="cancellation.loading" @click="onCancel">
          Отменить запись
        </v-btn>
      </template>
    </v-sheet>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'CancelAppointment',
  data() {
    return {
      token: '',
    };
  },
  computed: {
    ...mapGetters('publicCalendar', ['cancellation']),
  },
  created() {
    this.token = this.readTokenFromHash();
  },
  methods: {
    ...mapActions('publicCalendar', ['cancelAppointment']),
    readTokenFromHash() {
      // Формат ссылки из письма: HOST/calendar/appointments/cancel#token=... (не query-параметр).
      const hash = window.location.hash || '';
      const match = hash.match(/token=([^&]+)/);
      return match ? decodeURIComponent(match[1]) : '';
    },
    async onCancel() {
      try {
        await this.cancelAppointment(this.token);
      } catch {
        // состояние (успех/конфликт/ошибка) уже отражено в cancellation через стор
      }
    },
  },
};
</script>
